import { ChangeEvent } from "react";
import "./switch.scss";

interface SwitchProps {
  checked?: boolean;

  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

function Switch({ checked, onChange }: SwitchProps) {
  return (
    <label className="switch-control">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="track">
        <span className="peg"></span>
      </span>
    </label>
  );
}

export default Switch;
